export default __webpack_public_path__ + "static/magdad-a06b65b1d891ccff995b244f8eb752c6.png";